import { gql } from "@apollo/client";

export const QUERY_FORM3454C_VERSION = gql`
  query studentForm3454C(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454C(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      districtImplementedScientificProcess
      districtImplementedServiceDiscrepancyModel
      severeDiscrepancyExists
      severeDiscrepancyAreas
      problemDescription
      problemAnalysis
      problemSolving
      interventions
      educationalProgress
      discrepancy
      instructionalNeeds
      additionalInformation
      signatureName
      signatureTitle
      formAction
      formStatus
    }
  }
`;
